export enum CollaborationReviewDocumentType {
  Review = 1,
  Reference = 2,
}
